export enum GameState {
    WaitResult = 2,
    Hi = 0x7000,
    Lo,
    HiLo11
}